import $ from "jquery";

$(function () {

});

